<template>
  <div class="AddressPconment">
    <van-cell-group>
      <van-cell title="热力公司" is-link :value="district" @click="onCompany"/>
      <van-cell title="小区" is-link :value="villageData.villageName" @click="onVillage"/>
    </van-cell-group>
    <van-cell-group>
      <van-cell title="楼栋" is-link :value="buildingData.buildingName" @click="onBuilding"/>
      <van-cell title="单元" is-link :value="unit?unit:'请选择单元'" @click="onUnit"/>
      <van-cell title="楼层" is-link :value="floorNo?floorNo:'请选择楼层'" @click="onFloor"/>
      <van-cell title="室号" is-link :value="roomNo?roomNo:'请选择室号'" @click="onRoom"/>
    </van-cell-group>
    <van-cell-group>
      <van-cell title="分组" is-link :value="TagValue?TagValue:'请选择分组'" @click="onTag"/>
      <van-cell title="设为默认">
        <van-switch
          :value="checked"
          active-color="#07c160"
          inactive-color="#dadee1"
          @input="onDefaultFlag"
        />
      </van-cell>
    </van-cell-group>
    <van-col span="24" type="flex" justify="space-between" class="barBtn">
      <van-button round type="danger" size="large" class="saveBth" :disabled="isSave" @click.prevent="UpdateInfo">保存</van-button>
    </van-col>
    <van-popup
      v-model="isShow"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onCompanyConfirm"
        @cancel="isShow = false"
        v-show = 'isCompany'
        value-key="companyName"
      />
      <van-picker
        show-toolbar
        :columns="BUFRinfo"
        @confirm="onUFRConfirm"
        @cancel="isShow = false"
        v-show = 'isUFRpop'
        :value-key="infoKey"
      />
    </van-popup>
    <div class="popCon" v-show="isVillage" v-if="villageList">
      <div class="returnBtn"><van-button icon="arrow-left" type="primary" @click="isVillage=false">返回</van-button></div>
      <van-index-bar :index-list="indexList" sticky >
        <div v-for="index in indexList" :key="index">
          <van-index-anchor :index="index"/>
          <div v-for="item in villageList">
            <van-cell :title="item.villageName" v-if="item.villageNameS == index" @click="VillageSelect(item.villageId,item.villageName)"/>
          </div>
        </div>
      </van-index-bar>
    </div>
    <van-popup
      class="tagBox"
      v-model="isTagShow"
      position="bottom"
      :style="{ height: '20%' }">
      <van-swipe :loop="false" :width="100" class="tagBar" :show-indicators="false">
        <van-swipe-item v-for="(item,index) in Taglist" :key="index" @click="TagChange(item)">{{item}}</van-swipe-item>
      </van-swipe>
    </van-popup>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { reqCompany, reqVillage, reqBuilding, reqBuildingDetail, reqRoomTaglist, reqAddressAdd, reqAddressList, reqAddressEdit} from '../../api'
  import vPinyin from '../../common/js/vue-py.js';
  import commonJS from '../../common/js/commonJS.js';
  export default {
    name:"addresscheck",
    i18n: {
      'zh-CN': {
        text: '文本',
        customIndexList: '自定义索引列表'
      },
      'en-US': {
        text: 'Text',
        customIndexList: 'Custom Index List'
      }
    },
    data() {
      return {
        isSave:true,
        isShow: false,
        userCardNumber:'',
        city:'请选择您所在的城市',
        isCity:false,
        district:'请选择所属热力公司',
        isDistrict:false,
        villageData:{
          villageId:'',
          villageName:'请选择您所在的小区',
        },
        villageList:[],
        isVillage:false,
        columns:[],
        buildingData:{
          buildingName:'请选择您所在的楼栋',
          buildingId:''
        },
        unit:'',
        floorNo:'',
        roomNo:'',
        roomId:'',
        TagValue:'',//标签
        defaultFlag:0,//默认开关
        checked:false,
        isTagShow:false,//标签弹窗
        Taglist:[],//标签列表
        isUFRpop:false,
        BUFRinfo:[],
        infoKey:'buildingName',//分别四个 楼栋 单元 楼层 室号 的value-key不一样  动态设置
        AreaCity:{
          trendName:'',
          trendId:''
        },
        AreaDistrict:{
          trendName:'',
          trendId:''
        },
        indexList:[],
        address:'',
        userId:'',
        urId:'',
		companyData:{},
		isCompany:false
      }
    },
    created(){
      this.userId = this.$cookies.get('userInfo').userId
      this.roomId = this.$route.query.roomId
      console.log(this.$route.query.roomId);
    },
    mounted(){
      if(this.roomId){
        document.title = '编辑地址';
        this.getAddressList();
      }
    },
    methods:{
      /*
     * 编辑事获取订单详情
     * */
      getAddressList(){
        let data={
          userId:this.userId,
          roomId:this.roomId
        }
        //获取对应小区
        reqAddressList(data).then(res => {
          if(res.success){
            this.urId = res.data[0].urId
            // this.AreaCity.trendName=res.data[0].city
            // this.city=res.data[0].city
            // this.AreaCity.trendId=res.data[0].cityId

            // this.AreaDistrict.trendName=res.data[0].area
            this.district=res.data[0].companyName
            // this.AreaDistrict.trendId=res.data[0].areaId
			this.companyData.companyName = res.data[0].companyName
			this.companyData.companyId = res.data[0].companyId
            this.villageData.villageName=res.data[0].villageName
            this.villageData.villageId=res.data[0].villageId

            this.buildingData.buildingName=res.data[0].buildingName
            this.buildingData.buildingId=res.data[0].buildingNo
            this.unit=res.data[0].unit
            this.floorNo=res.data[0].floorNo
            this.roomNo=res.data[0].roomNo
            this.roomId=res.data[0].roomId
            this.TagValue = res.data[0].tag
            this.defaultFlag=res.data[0].default_flag
            if(this.defaultFlag==1){
              this.checked = true
            }else if(this.defaultFlag==0){
              this.checked = false
            }
            let testVerify = this.testVerify();
            if(!testVerify){
              this.isSave = true
            }else{
              this.isSave = false
            }
          }else {
            Toast.fail({message:res.msg,className:'apiLoading'});
          }
        })
      },
     //  /*
     //  * 获取城区
     //  * */
     //  reqAreaData(AreaData){
     //    if(!AreaData){
     //      AreaData = {}
     //    }
     //    reqArea(AreaData).then(res => {
     //      if(res.success){
     //        this.columns = res.data
     //      }else {
     //        Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
     //      }
     //    })
     //  },
     //  /*
     //  * 点击选取城市
     //  * */
     //  onCity(){
     //    this.isShow = true
     //    this.isCity = true
     //    this.isDistrict = false
     //    this.reqAreaData();
     //  },
     //  /*
     //  * 点击选取区
     //  * */
     //  onDistrict(){
     //    if(!this.AreaCity.trendId||!this.AreaCity.trendName){
     //      Toast.fail({message:'请先选择城市！',className:'apiLoading'});
     //      return false
     //    }
     //    this.reqAreaData(this.AreaCity);
     //    this.isShow = true
     //    this.isCity = false
     //    this.isDistrict = true
     //  },
     //  /*
     //  * 点击城市选取弹窗确定
     //  * */
     //  onCityConfirm(value, index){
     //    this.AreaCity.trendName = value.regionName
     //    this.AreaCity.trendId = value.regionId;
     //    this.AreaDistrict.trendName =''
     //    this.AreaDistrict.trendId =''
     //    this.district = '请选择您所在的地区'
     //    this.villageData.villageId = '';
     //    this.villageData.villageName = '请选择您所在的小区';
     //    this.isShow = false
     //    this.isCity = false
     //    this.city = value.regionName
     //  },
     //  /*
     // * 点击区选取弹窗确定
     // * */
     //  onDistrictConfirm(value, index){
     //    this.AreaDistrict.trendName = value.regionName
     //    this.AreaDistrict.trendId = value.regionId;
     //    this.isShow = false
     //    this.isDistrict = false
     //    this.district = value.regionName
     //    this.villageData.villageId = '';
     //    this.villageData.villageName = '请选择您所在的小区';
     //  },
	 /*
	 *  点击获取热力公司列表
	 * */	  
	 onCompany(){
	 		  this.district = '请选择所属热力公司'
	 		  this.isShow = true
	 		  this.isDistrict = false
	 		  this.isCompany =true
	 		  this.reqCompanyData();
	 },
	  /*
	  * 点击热力公司选取弹窗确定
	  * */
	  onCompanyConfirm(value, index){
	 		   console.log(value);
	    this.companyData.companyName = value.companyName
	    this.companyData.companyId = value.companyId;
	    this.isShow = false
	 		 this.isCompany =false
	 		 this.district = value.companyName
		   this.villageData.villageId = '';
		   this.villageData.villageName = '请选择您所在的小区';
	  },
	 //获取热力公司
	 reqCompanyData(){
		reqCompany().then(res => {
			if(res.success){
				this.columns = res.data
			}
		})
	 },
      /*
      *  点击获取小区列表
      * */
      onVillage(){
        let _that = this
        _that.isVillage = false
        if(this.companyData.companyId){
          let data = {
            companyId:this.companyData.companyId // TODO 微信进来取companyId
          }
          //获取对应小区
          reqVillage(data).then(res => {
            if(res.success){
              _that.villageList = res.data;
              for(let k in _that.villageList){
                let villageNameS = '',villageNameP='';
                //把小区转换成拼音取首字母排序去重
                villageNameP = vPinyin.chineseToPinYin(_that.villageList[k].villageName);
                villageNameS= villageNameP.substr(0,1);
                _that.indexList.push(villageNameS);
                _that.indexList = commonJS.unique5(_that.indexList)
                _that.indexList = commonJS.letterSort(_that.indexList)
                _that.villageList[k].villageNameS = villageNameS
              }
              if(_that.villageList.length == 0){
                Toast.fail({message:'暂无开通缴费的小区！',className:'apiLoading'});
              }else if(_that.villageList.length > 0){
                _that.isVillage = true
              }
            }else {
              Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
            }
          })
        }else{
          Toast.fail({message:'请先选择所属热力公司！',className:'apiLoading'});
        }
      },
      /*
      *  点击选择小区
      * */
      VillageSelect(villageId,villageName){
        this.villageData.villageId = villageId;
        this.villageData.villageName = villageName;
        this.buildingData.buildingName='请选择您所在的楼栋'
        this.buildingData.buildingId=''
        this.unit=''
        this.floorNo=''
        this.roomNo=''
        this.roomId=''
        this.isVillage = false
      },
      /*
      * 下拉框点击取消
      * */
      cnacelShow(){
        this.isShow = false
        this.isCity = false
        this.isDistrict = false
        this.isUFRpop = false
      },
      /*
     * 点击获取楼栋列表
     * */
      onBuilding(){
        if(this.villageData.villageId){
          this.infoKey = 'buildingName'
          let _that = this
          //获取楼栋列表
          let data = {
            villageId:_that.villageData.villageId
          }
          reqBuilding(data).then(res => {
            if(res.success){
              _that.BUFRinfo = res.data
              if(_that.BUFRinfo.length == 0){
                Toast.fail({message:'暂无开通缴费的楼栋！',className:'apiLoading'});
              }
            }else {
              Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
            }
          })
          this.isShow = true
          this.isUFRpop = true
        }else{
          Toast.fail({message:'请先选择小区！',className:'apiLoading'});
        }
      },
      /*
      * 点击获取单元列表
      * */
      onUnit(){
        if(this.buildingData.buildingId){
          this.infoKey = 'unit'
          this.isShow = true
          this.isUFRpop = true
          let data = {
            buildingId:this.buildingData.buildingId
          }
          this.getBuildingDetail(data);
        }else{
          Toast.fail({message:'请先选择楼栋！',className:'apiLoading'});
        }
      },
      /*
      * 点击获取楼层列表
      * */
      onFloor(){
        if(this.buildingData.buildingId&&this.unit){
          this.infoKey = 'floorNo'
          this.isShow = true
          this.isUFRpop = true
          let data = {
            buildingId:this.buildingData.buildingId,
            unit:this.unit
          }
          this.getBuildingDetail(data);
        }else{
          Toast.fail({message:'请先选择楼栋！',className:'apiLoading'});
        }
      },
      onRoom(){
        if(this.buildingData.buildingId&&this.floorNo){
          this.infoKey = 'roomNo'
          this.isShow = true
          this.isUFRpop = true
          let data = {
            buildingId:this.buildingData.buildingId,
            unit:this.unit,
            floorNo:this.floorNo
          }
          this.getBuildingDetail(data);
        }else{
          Toast.fail({message:'请先选择楼栋！',className:'apiLoading'});
        }
      },
      /*
      * 楼栋 单元 楼层 室号 点击确定
      * */
      onUFRConfirm(value){
        if(this.infoKey == 'buildingName'){
          this.buildingData.buildingName = value.buildingName
          this.buildingData.buildingId = value.buildingId
          this.unit=''
          this.floorNo=''
          this.roomNo=''
          this.roomId=''
        }else if(this.infoKey == 'unit'){
          this.unit = value.unit
          this.floorNo=''
          this.roomNo=''
          this.roomId=''
        }else if(this.infoKey == 'floorNo'){
          this.floorNo = value.floorNo
          this.roomNo=''
          this.roomId=''
        }else if(this.infoKey == 'roomNo'){
          this.roomNo = value.roomNo
          this.roomId = value.roomId
          let testVerify = this.testVerify();
          if(!testVerify){
            this.isSave = true
          }else{
            this.isSave = false
          }
        }
        this.isShow = false
        this.isUFRpop = false
        this.BUFRinfo = []
      },
      /*
      * 获取楼栋明细
      * */
      getBuildingDetail(data){
        let _that = this
        reqBuildingDetail(data).then(res => {
          if(res.success){
            _that.BUFRinfo = res.data
            if(_that.BUFRinfo.length == 0){
              Toast.fail({message:'暂无开通！',className:'apiLoading'});
            }
          }else {
            Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
          }
        })
      },
      /*
     * 获取标签
     * */
      onTag(){
        reqRoomTaglist().then(res => {
          if(res.success){
            if(res.data.tags == ''){
              Toast.fail({message:'暂无数据！',className:'apiLoading'});
            }else{
              this.Taglist = res.data.tags.split(',');
              this.isTagShow = true;
            }
          }else {
            Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
          }
        })
      },
      /*
      * 选择标签
      * */
      TagChange(tag){
        this.TagValue = tag;
        this.isTagShow = false;
        let testVerify = this.testVerify();
        if(!testVerify){
          this.isSave = true
        }else{
          this.isSave = false
        }
      },
      /*
      * 默认切换
      * */
      onDefaultFlag(checked){
        if(checked){
          this.checked = checked
          this.defaultFlag = 1
        }else{
          this.checked = checked
          this.defaultFlag = 0
        }
      },
      /*
     *  必填验证
     * */
      testVerify(){
       if(!this.companyData.companyId||!this.companyData.companyName){
         Toast.fail({message:'请选择所属热力公司！',className:'apiLoading'});
         return false
       }
        if(!this.villageData.villageName||!this.villageData.villageId){
          Toast.fail({message:'请选择所在小区！',className:'apiLoading'});
          return false
        }
        if(!this.buildingData.buildingName||!this.buildingData.buildingId){
          Toast.fail({message:'请选择所在楼栋！',className:'apiLoading'});
          return false
        }
        if(!this.unit){
          Toast.fail({message:'请选择所在单元！',className:'apiLoading'});
          return false
        }
        if(!this.floorNo){
          Toast.fail({message:'请选择所在楼层！',className:'apiLoading'});
          return false
        }
        if(!this.roomId){
          Toast.fail({message:'请选择所在室号！',className:'apiLoading'});
          return false
        }
        if(!this.TagValue){
          Toast.fail({message:'请选择分组！',className:'apiLoading'});
          return false
        }
        return true
      },
      /*
      * 保存
      * */
      UpdateInfo(){
        let _that = this
        let testVerify = this.testVerify();
        if(testVerify){
          if(this.$route.query.roomId){
            //保存地址
            let data = {
              urId:this.urId,
              defaultFlag:this.defaultFlag,
              tag:this.TagValue,
              roomId:this.roomId
            }
            console.log(data);
            reqAddressEdit(data).then(res => {
              if(res.success){
                Toast.success({message:'编辑成功！',className:'apiLoading',onClose:function(){
                    _that.$router.push({
                      path:'/addressmanage',
                      name:'addressmanage'
                    })
                  }});
              }else {
                Toast.fail({message:res.msg,className:'apiLoading'});
              }
            })
          }else{
            //保存地址
            let data = {
              userId:this.userId,
              defaultFlag:this.defaultFlag,
              tag:this.TagValue,
              roomId:this.roomId
            }
            reqAddressAdd(data).then(res => {
              if(res.success){
                Toast.success({message:'保存成功！',className:'apiLoading',onClose:function(){
                    _that.$router.push({
                      path:'/addressmanage',
                      name:'addressmanage'
                    })
                  }});
              }else {
                Toast.fail({message:res.msg,className:'apiLoading'});
              }
            })
          }
        }else{
          this.isSave = true
          Toast.fail({message:'请填写房屋信息！',className:'apiLoading'});
        }
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .AddressPconment
    .van-cell-group
      margin-top 8px
      .van-cell
        height 98px!important
        line-height 98px
        font-size 30px
        color #222222
        padding-left 40px
        .van-cell__value
          font-size 28px
        .van-cell__left-icon, .van-cell__right-icon
          font-size 26px
          margin 0px 10px
          line-height 98px
        .van-field__control
          text-align right
          padding-right 40px
        .van-field__label
          width 120px
    .van-picker__toolbar
      height 85px
      .van-picker__confirm, .van-picker__cancel
        font-size 28px
        line-height 85px
    .van-picker-column
      font-size 32px
    .barBtn
      padding 10% 40px 0px
      .saveBth
        color #ffffff
        font-size 32px
        background #ff6d02
        height 88px
        margin-top 100px
        line-height 88px
    .van-popup
      box-sizing border-box
      padding 20px
      &--right
        width 100%
        height 100%
    .popCon
      width 100%
      height 100%
      position absolute
      background #ffffff
      top 0px
      left 0px
      padding-bottom 100px
      z-index 9
      .returnBtn
        background #ebedf0
        margin-bottom 10px
    .van-index-bar
      padding 0px 30px
      .van-index-bar__index
        font-size 24px
        line-height 40px
      .van-index-anchor
        font-size 30px
        background #ccc
        padding 8px 10px
      .van-cell
        font-size 28px
        padding 10px 20px
        line-height 45px
        border-bottom 1px solid #ccc
    .tagBox
      margin 0px 5%
      width 90%
    .tagBar
      margin 40px 20px
      .van-swipe-item
        display inline-block
        background #ff6d02
        width 130px!important
        margin 20px 10px
        color #fff
        border-radius 50%
        text-align center
        font-size 28px
        height 30px!important
        padding 50px 0px
	.van-picker-column__item
		height 1rem
</style>



// WEBPACK FOOTER //
// src/pages/AddressManage/addAddress.vue